import { render, staticRenderFns } from "./MobileProductMenu.vue?vue&type=template&id=580be725&scoped=true"
import script from "./MobileProductMenu.vue?vue&type=script&lang=js"
export * from "./MobileProductMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580be725",
  null
  
)

export default component.exports